// FILE: src/components/ProtectedRoute.jsx
import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { reasonForCode } from "../i18n/errors";

/**
 * ProtectedRoute
 *
 * @param {ReactNode} children - The protected component(s).
 * @param {string[]} roles - Optional array of roles allowed to view this route (e.g. ['admin']).
 */
export default function ProtectedRoute({ children, roles = [] }) {
  const { user, role, endReason } = useSelector((state) => state.auth);

  // Not signed in. If the server ended the session, /login says why (B-6).
  if (!user) {
    const to = endReason ? `/login?reason=${reasonForCode(endReason)}` : "/login";
    return <Navigate to={to} replace />;
  }

  // Check for required roles (if any)
  if (roles.length > 0 && !roles.includes(role)) {
    return <Navigate to="/403" replace />;
  }

  return children;
}
